module.exports = __webpack_public_path__ + "img/2.184dc064.png";